import React from 'react'
import { CloseAlt } from '@ticketswap/comets'
import styled from '@emotion/styled'
import {
  useDialog,
  DialogWindow,
  DialogHeader,
  DialogAdornment,
  DialogBody,
  Text,
  space,
} from '@ticketswap/solar'
import useLocalStorage from '~/hooks/useLocalStorage'
import AppStoreBadges from '~/components/AppStoreBadges'
import AppsNotification from '~/components/AppsNotification'

const StyledText = styled(Text)`
  text-align: center;
`

const StyledAppStoreBadges = styled(AppStoreBadges)`
  margin-top: ${space[16]};
  justify-content: center;
  text-align: center;
`

function AppsAdoptionDialog({ t, event, ...props }) {
  const [impressions, setImpressions] = useLocalStorage('apps_adoption_dialog_impressions', 0)
  const { show, hide, getWindowProps } = useDialog({
    onExited: () => {
      return requestAnimationFrame(() => setImpressions(impressions + 1))
    },
  })

  if (parseInt(impressions) > 0) {
    return props.children({ show })
  }

  return (
    <>
      {props.children({ show })}
      <DialogWindow {...getWindowProps()}>
        <DialogHeader>
          {t('event-eventtype:appsAdoption.dialog.title')}
          <DialogAdornment right>
            <button onClick={hide}>
              <CloseAlt size={24} />
            </button>
          </DialogAdornment>
        </DialogHeader>
        <AppsNotification
          t={t}
          eventName={event?.name}
          image="/static/images/apps/mobile-screen-full.jpg"
        />
        <DialogBody>
          <StyledText as="p">
            {event?.isPopular && (
              <strong>
                {t('event-eventtype:appsAdoption.dialog.highDemand', {
                  eventName: event?.name,
                })}{' '}
              </strong>
            )}
            {t('event-eventtype:appsAdoption.dialog.text')}
          </StyledText>
          <StyledAppStoreBadges trackingContext="ALERTS_TOGGLE_ADOPTION_DIALOG" />
        </DialogBody>
      </DialogWindow>
    </>
  )
}

export default AppsAdoptionDialog
